import React from "react";
import get from "lodash/get";
import map from "lodash/map";
import cloneDeep from "lodash/cloneDeep";
import forEach from "lodash/forEach";
import { connect } from "react-redux";
import {
  Alert,
  Icon,
  Layout,
  Input,
  Table,
  Switch,
  Button,
  Modal,
  Badge,
  message,
  Tooltip,
  Select,
  Checkbox,
} from "antd";

import classes from "./ConsentUnassignedRecords.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getConsentUnassignedRecordsRequest,
  getSitesRequest,
  getConsentSettingsWfRequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import { getDocumentPublicReadPermission } from "../../reducers/user/selectors";
import { withNamespaces } from "react-i18next";
import FileLink from "../../components/FileLink/FileLink";
import moment from "moment";
import { withParams } from "../../utils/url";
const routes = require("../../routes.json");

const { Content } = Layout;
const { Search } = Input;
const { Option } = Select;

class ConsentUnassignedRecords extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      documents: [],
      nameSearch: null,
      errorMessage: null,
      responseMessage: null,
      isLoading: false,
      sites: [],
      site: null,
      filter: null,
      order: "desc",
      currentPage: 1,
      total: 1,
      pageSize: 25,
      eventVisibleDropdown: false,
      eventsSelected: {},
      sortedInfo: { columnKey: "consent_date", order: "descend" },
      documentEdit: null,
      filterBy: null,
      filterValue: null,
      filtersBy: [],
      filtersValue: [],
      created_by_me: false,
      consentSettings: {},
    };
  }

  async componentDidMount() {
    this.onNameSearch();

    try {
      const { data } = await getSitesRequest();
      this.getConsentSettingsRequest();
      this.setState({ sites: data });
    } catch (e) {
      console.log(e);
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
    }
  }

  getConsentSettingsRequest = async () => {
    try {
      const { data } = await getConsentSettingsWfRequest();
      this.setState({
        consentSettings: data,
      });
    } catch (e) {
      console.log(e);
    }
  };

  onNameSearch = async (value) => {
    this.setState(
      {
        nameSearch: value,
        filterBy: null,
        filterValue: null,
        eventsSelected: {},
        currentPage: 1,
      },
      this.getConsents
    );
  };

  getConsents = async (
    page = this.state.currentPage,
    per_page = this.state.pageSize
  ) => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const filters = {};

      forEach(this.state.filtersBy, (item, i) => {
        filters[item] = this.state.filtersValue[i];
      });

      const { data } = await getConsentUnassignedRecordsRequest({
        nameSearch: this.state.nameSearch,
        order_direction: this.state.order,
        order_column: get(this.state, "sortedInfo.columnKey"),
        page,
        per_page,
        filter_by: this.state.filtersBy,
        filter_value: this.state.filtersValue,
        created_by_me: this.state.created_by_me,
        ...filters,
      });

      if (Array.isArray(data.data)) {
        this.setState({
          documents: data.data,
          total: data.total_pages * per_page,
          currentPage: page,
        });
      } else {
        this.setState({
          documents: [data],
          total: 1 * per_page,
          currentPage: page,
        });
      }
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        documents: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }

    this.setState({ isLoading: false });
  };

  onNameChange = (e) => {
    this.setState({ nameSearch: e.target.value });
  };

  handleTableChange = (pagination, filters, sorter) => {
    this.setState(
      {
        isLoading: true,
        pageSize: pagination.pageSize,
        sortedInfo: sorter,
        order:
          get(sorter, "order") === "ascend"
            ? "asc"
            : get(sorter, "order") === "descend"
            ? "desc"
            : "asc",
      },
      () => this.getConsents(pagination.current, pagination.pageSize)
    );
  };

  handleFilterChange = (index) => (value) => {
    this.setState((state) => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);
      filtersBy[index] = value;
      delete filtersValue[index];
      return { filtersBy, filtersValue };
    });
  };
  handleFilterValueChange = (index) => (value) => {
    this.setState((state) => {
      const filtersValue = cloneDeep(state.filtersValue);
      filtersValue[index] = value;
      return { filtersValue, currentPage: 1 };
    }, this.getConsents);
  };

  clearFilter = (index) => () => {
    this.setState((state) => {
      const filtersBy = cloneDeep(state.filtersBy);
      const filtersValue = cloneDeep(state.filtersValue);

      filtersBy.splice(index, 1);
      filtersValue.splice(index, 1);

      return { filtersBy, filtersValue, currentPage: 1 };
    }, this.getConsents);
  };

  clearFilters = () => {
    this.setState({ nameSearch: null, currentPage: 1 }, this.getConsents);
  };

  onChangeOwnerStatus = () => () => {
    this.setState(
      (_) => ({ created_by_me: !this.state.created_by_me, currentPage: 1 }),
      this.getConsents
    );
  };

  renderFilterItem = (index = this.state.filtersBy.length) => {
    const { filtersBy, filtersValue, sites } = this.state;

    return (
      <div className={classes.wrapperFilterItem} key={filtersBy[index]}>
        <div className={classes.searchWrapperFilter}>
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("Filter")} by
            </b>
            <Select
              onChange={this.handleFilterChange(index)}
              value={filtersBy[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("Select")}
            >
              <Option
                value="workflow"
                disabled={filtersBy.includes("workflow")}
              >
                {this.props.i18n.t("Workflow")}
              </Option>
              <Option
                value="site_code"
                disabled={filtersBy.includes("site_code")}
              >
                {this.props.i18n.t("Site code")}
              </Option>
            </Select>
          </label>
        </div>

        {filtersBy[index] === "workflow" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("Workflow")}
            </b>
            <Select
              onChange={this.handleFilterValueChange(index)}
              value={filtersValue[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("Select")}
            >
              {get(this.state.consentSettings, "workflow_type", []).map(
                (item) => (
                  <Option key={item.id} value={item.value}>
                    {item.name}
                  </Option>
                )
              )}
            </Select>
          </label>
        )}

        {filtersBy[index] === "site_code" && (
          <label className={classes.searchWrapperFilterItem}>
            <b className={classes.searchWrapperLabel}>
              {this.props.i18n.t("Site")}
            </b>
            <Select
              onChange={this.handleFilterValueChange(index)}
              value={filtersValue[index]}
              style={{ width: "100%" }}
              placeholder={this.props.i18n.t("Select")}
            >
              {this.state.sites
                .filter((site) => site.site_type === "randomization")
                .sort(
                  (a, b) =>
                    +`${a.code}`.split("-")[0] - +`${b.code}`.split("-")[0]
                )
                .map((site) => (
                  <Option key={site.code} value={site.code}>
                    {site.code} - {site.name}
                  </Option>
                ))}
            </Select>
          </label>
        )}

        {filtersValue[index] !== undefined && (
          <span
            className={classes.clearButton}
            onClick={this.clearFilter(index)}
          >
            {this.props.i18n.t("Remove")}
          </span>
        )}
      </div>
    );
  };

  render() {
    const {
      errorMessage,
      isLoading,
      responseMessage,
      nameSearch,
      documents,
      currentPage,
      total,
      pageSize,
      sortedInfo,
      filtersBy,
      filtersValue,
      created_by_me,
    } = this.state;

    const columns = [
      {
        dataIndex: "site_id",
        key: "site_id",
        title: this.props.i18n.t("Site"),
        render: (val, row) => get(row, "site.name", ""),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "site_id" && sortedInfo.order,
      },
      {
        dataIndex: "consent_date",
        key: "consent_date",
        title: this.props.i18n.t("Consent date"),
        render: (val) => (
          <span>{moment(val).format("YYYY MMM DD, HH:mm")} UTC</span>
        ),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "consent_date" && sortedInfo.order,
      },
      {
        dataIndex: "subject_identifier",
        key: "subject_identifier",
        title: this.props.i18n.t("Subject Identifier"),
        render: (val) => val,
      },
      {
        dataIndex: "subject_code",
        key: "subject_code",
        title: this.props.i18n.t("Subject code"),
        render: (val) => val,
      },
      {
        dataIndex: "consent_type",
        key: "consent_type",
        title: this.props.i18n.t("Consent type"),
        render: (val, row) => (
          <span>
            {get(row, "consent_type_settings.consent_exists_method_type")}{" "}
            {get(row, "consent_type_settings.consent_exists_person_type")}
          </span>
        ),
        sorter: true,
        sortOrder:
          get(sortedInfo, "columnKey") === "consent_type" && sortedInfo.order,
      },
      {
        dataIndex: "consent_version",
        key: "consent_version",
        title: this.props.i18n.t("Consent version"),
        render: (val) => val,
      },
      {
        dataIndex: "workflow",
        key: "workflow",
        title: this.props.i18n.t("Workflow"),
        render: (val) => val,
      },
      {
        dataIndex: "files",
        key: "files",
        title: this.props.i18n.t("Files"),
        render: (val) => (
          <div>
            {map(val, ({ link, name }, i) => (
              <div key={i}>
                {link ? (
                  <div style={{ margin: "5px 0 0" }}>
                    <FileLink url={link} text={name} />
                  </div>
                ) : (
                  <div style={{ margin: "5px 0" }}>
                    <div style={{ margin: "5px 0" }}>
                      {this.props.i18n.t("Consent file missing.")}
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        ),
      },
      {
        dataIndex: "id",
        key: "id",
        title: this.props.i18n.t("Actions"),
        render: (val, row) => (
          <div>
            {row.can_randomize &&
              (row.subject_code ? (
                <a
                  href={withParams(routes.admin.randomize, {
                    subjectCode: get(row, "subject_code"),
                    siteCode: get(
                      row,
                      "site.code"
                    ),
                  })}
                >
                  <Button type="primary" size="small" htmlType="button">
                    {this.props.i18n.t("Randomize")}
                  </Button>
                </a>
              ) : (
                <a
                  href={withParams(routes.admin.randomize, {
                    consentRecordID: row.id,
                    siteCode: get(row, "site.code"),
                  })}
                >
                  <Button type="primary" size="small" htmlType="button">
                    {this.props.i18n.t("Randomize")}
                  </Button>
                </a>
              ))}
            {!row.can_randomize && row.consent_email_status && (
              <div style={{ margin: "5px 0" }}>
                {this.props.i18n.t("Status")}:{" "}
                <i>{row.consent_email_status.replace(/_/g, " ")}</i>
              </div>
            )}
          </div>
        ),
      },
    ];

    return (
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("NamespaceConsent:Unassigned consent records")}
            </h3>

            <div className={classes.searchWrapper}>
              <label className={classes.searchWrapperSearch}>
                <b className={classes.searchWrapperLabel}>
                  {this.props.i18n.t("Search")}
                </b>
                <Search
                  enterButton={this.props.i18n.t("Search")}
                  size="large"
                  onSearch={this.onNameSearch}
                  value={nameSearch}
                  onChange={this.onNameChange}
                  style={{ maxWidth: "500px" }}
                />
              </label>

              <span className={classes.clearButton} onClick={this.clearFilters}>
                {this.props.i18n.t("Clear")}
              </span>
            </div>

            <h4 className="headline-default">{this.props.i18n.t("Filter")}</h4>

            <div className={classes.wrapperFilters}>
              <div className={classes.searchWrapperFilterItemApprove}>
                <Checkbox
                  onChange={this.onChangeOwnerStatus("created_by_me")}
                  checked={!!created_by_me}
                >
                  {this.props.i18n.t("NamespaceDocumentsEditor:Created by me")}
                </Checkbox>
              </div>

              {filtersBy.map((_, index) => this.renderFilterItem(index))}

              {filtersBy.length === filtersValue.length &&
                filtersBy.length !== 4 &&
                this.renderFilterItem()}
            </div>

            {errorMessage && (
              <Alert
                type="error"
                message={errorMessage}
                className={classes.alert}
              />
            )}

            {responseMessage && (
              <Alert
                type="success"
                message={responseMessage}
                className={classes.alert}
              />
            )}

            <div className={classes.tableWrapper}>
              <Table
                columns={columns}
                dataSource={documents}
                loading={isLoading}
                rowKey="id"
                onChange={this.handleTableChange}
                pagination={{
                  onShowSizeChange: (current, size) => {
                    this.setState({ pageSize: size });
                  },
                  current: currentPage,
                  total,
                  pageSize,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "25", "50", "100"],
                  position: "both",
                }}
              />
            </div>

            {/*{isLoading && <Icon type="loading" />}*/}
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  documentPublicReadPermission: getDocumentPublicReadPermission(state),
});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(ConsentUnassignedRecords))
);



// WEBPACK FOOTER //
// ./src/containers/ConsentUnassignedRecords/ConsentUnassignedRecords.js